import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, PropertyValues, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './ghs-tab-panel.css.lit';
import { MobileController } from '../../controllers/mobile-controller';

/**
 * The Tab Panel component
 *
 * @element ghs-tab-panel
 */
@customElement('ghs-tab-panel')
export class GhsTabPanel extends OutlineElement {
  private mobileController = new MobileController(this);
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Whether the panel is active/open.
   * Controlled by parent ghs-tabs component.
   */
  @property({ type: Boolean, reflect: true })
  active = false;

  /**
   * Used to provided a unique ID
   * for ghs-tabs component and accessibility purposes.
   */
  @property({ type: String, attribute: 'unique-id', reflect: true })
  uniqueId: string = Math.floor(Math.random() * 10000).toString();

  @state() isOpen = false;

  setPanelAttributes(): void {
    this.setAttribute('role', 'tabpanel');
    this.setAttribute('aria-labelledby', `${this.uniqueId}-button`);
    this.setAttribute('aria-hidden', this.active ? 'false' : 'true');
    this.setAttribute('id', `${this.uniqueId}-info`);
    if (!this.active) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }
  }

  protected update(changedProperties: PropertyValues) {
    this.setPanelAttributes();
    super.update(changedProperties);
  }

  render(): TemplateResult {
    const isMobile = this.mobileController.isMobile ? 'is-mobile' : null;
    const isActive = this.active ? 'active' : 'inactive';

    return html`
      <div class="tab-panel ${isMobile} ${isActive}">
        <slot></slot>
      </div>
    `;
  }
}
